<template>
    <div v-if="filteredEvents && filteredEvents.length > 0" class="event-lists">
            <carousel
                :per-page="loop"
                :mouse-drag="false"
                :navigationEnabled="true"
                navigationNextLabel='<i class="ion-chevron-right"></i>'
                navigationPrevLabel='<i class="ion-chevron-left"></i>'
            >
                <slide v-for="(data, index) in filteredEvents" :key="index">
                    <div class="wrap-filter-racing">
                        <div class="schedule-racing-card  red">
                            <div class="schedule-card inline-flex">
                                <div class="schedule-date">
                                    <h3 class="tx-black">
                                        {{ data.date }}
                                    </h3>
                                </div>
                                <div class="schedule-details">
                                    <h3 class="schedule-title">
                                        {{
                                            data.name.length > 27 ? data.name.substring(0, 27) + " ..." : data.name
                                        }}
                                    </h3>
                                    <span class="event-by"
                                        >Event by <strong> {{
                                            data.dealer
                                                ? data.dealer
                                                : data.author
                                        }}</strong></span
                                    >
                                    <div class="schedule-notif-share">
                                        <a
                                            :href="data.detail_url_web"
                                            class="notifyme flex flex-center tx-red"
                                             @click="trackerCheckEvent(data)"
                                        >
                                            Check Event
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </slide>
            </carousel>
    </div>
    <div v-else class="message">
        <h4>Belum ada event</h4>
    </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import { isMobile } from "mobile-device-detect";

export default {
    props: ["eventData"],
    components: {
        Carousel,
        Slide
    },
    data: function() {
        return {
            base_url:'',
            app_url:'',
            api_url:'',
            mobile: false,
            loaderevent:true,
            events:[],
            loop: isMobile ? 1 : 3,
            mobile: false,
            isUserSimulate: false,
            user: {},
        };
    },
    created() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.checkUserSimulate();

        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.mobile = isMobile;
        this.getEvent();
    },
    computed: {
        filteredEvents() {
            return this.events.filter(data => {
                return (data.name !== 'Test Event Nasional' && data.name !== 'Test Event Regional') 
                    || (data.name === 'Test Event Nasional' && this.isUserSimulate) 
                    || (data.name === 'Test Event Regional' && this.isUserSimulate);
            });
        }
    },
    methods: {
        getEvent() {
                this.loaderevent = true;
                axios.get(api_url+'/event/hcid?limit=9')
                    .then(response => {
                        this.events = response.data.data.event;
                        this.loaderevent = false;
                    }).catch(error => {
                        console.log(error);
                    });
        },
        trackerCheckEvent(data) {

                    var tracker = {
                        'event': 'checkEvent',
                        'eventDetail.category': 'Custom Event',
                        'eventDetail.action':'Check Event',
                        'eventDetail.label': data.name,
                        'eventType': data.type,
                        'month': data.month || 'all',
                        'province':  data.province || 'all'
                    }
                console.log(tracker);
            dataLayer.push(tracker)
        },
        checkUserSimulate() {
            const checkHcid = process.env.MIX_HCID_PAYMENT_TEST.split(",");
            if (this.user?.hcid !== undefined) {
                const user = this.user.hcid;
                if (checkHcid.includes(user.toString())) {
                    this.isUserSimulate = true;
                } else {
                    this.isUserSimulate = false;
                }
            } else {
                this.isUserSimulate = false;
            }

            console.log('isUserSimulate = ', this.isUserSimulate);
        },
    }
};
</script>

<style scoped lang="scss">
.schedule-card {
    display: inline-flex;
}
.schedule-racing-card {
    box-shadow: 8px 4px 25px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    margin-bottom: 30px;

    background: #282828;
}
.btn-black {
    border: solid 1px #dbdbdb;
    border-radius: 10px;
}
.btn-grey {
    border: solid 1px #eee;
    border-radius: 10px;
    background-color: #eeeeee;
}
.schedule-racing-card:before {
    position: absolute;
    content: "";
    top: 0;
    right: 0;
    width: 20px;
    height: 100%;
    background-color: #dbdbdb;
}
.schedule-racing-card.red:before {
    background-color: #e61b33;
}
.schedule-racing-card.black:before {
    background-color: #282828;
}
.schedule-racing-card.grey:before {
    background-color: #dbdbdb;
}
.wrap-racing-schedule {
    margin-top: 2em;
}
.wrap-filter-racing{
    margin:0 15px;
}
.event-lists{
    margin:0 -15px;
}
.schedule-card {
    position: relative;
    padding: 2em;
}
.schedule-date {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background-color: #f8f8f8;
    border-radius: 10px;
    padding: 15px 25px;
}
.schedule-date h3 {
    text-align: center;
    font-weight: 600;
    margin: 0;
}
.schedule-details {
    margin-left: 15px;
    h3 {
        font-weight: 600;
        font-size: 20px;
        color: #ffffff;
        margin-bottom: 5px;
    }
    span {
        font-weight: 600;
        font-size: 12px;
        color: #4f4f4f;
        strong {
            color: #fff;
        }
    }
}
.schedule-notif-share {
}
.schedule-status {
    font-size: 12px;
    padding: 4px 12px;
    border-radius: 10px;
    display: inline-block;
    font-weight: 600;
}
.schedule-location {
    font-weight: 600;
    margin: 15px 0 0;
}
.schedule-country {
    margin-top: 0;
    margin-bottom: 15px;
}
.notifyme {
    margin-top: 15px;
    background: none;
    border: 1px solid #686868;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 500;
    padding: 7px 14px;
    margin-right: 15px;
    color: #fff;
}
.notifyme:hover {
    color: #fff;
    background-color: #e61b33;
}
.notifyme span {
    margin-right: 5px;
    max-width: 12px;
    font-size: 16px;
}
.btn-schedule-racing {
    display: block;
    text-align: center;
    padding: 15px;
    border-radius: 10px;
    font-size: 16px;
    font-weight: 600;
}
.shares {
    position: absolute;
    bottom: 40px;
    left: 0;
    height: 0;
    overflow: hidden;
    -webkit-transform-origin: top;
    transform-origin: top;
    -webkit-transition: -webkit-transform 0.4s ease-in-out;
    transition: -webkit-transform 0.4s ease-in-out;
    transition: transform 0.4s ease-in-out;
    transition: transform 0.4s ease-in-out, -webkit-transform 0.4s ease-in-out;
    a {
        margin: 2px 0;
    }
}
.active .shares {
    height: 115px;
}
</style>
